import { http } from "msw";

import { MESSAGE_TYPE } from "@/domains/messages/models/constants";
import type { SendMessageRequest } from "@/domains/messages/models/types";
import { isoNow } from "@/mocks/dates";
import { withSession } from "@/mocks/resolvers";
import { errorResponse, successResponse } from "@/mocks/responses";
import type { PersonaState } from "@/mocks/store";
import type { MessageWire } from "@/mocks/types";

export const appendMessage = (
  state: PersonaState,
  message: Pick<MessageWire, "type" | "content">,
) => {
  const lastMessageId = state.messages.at(-1)?.id ?? state.threadId * 100;
  const newMessage: MessageWire = {
    ...message,
    id: lastMessageId + 1,
    threadId: state.threadId,
    metadata: [],
    createdAt: isoNow(),
  };

  state.messages.push(newMessage);

  return newMessage;
};

export const createMessageHandlers = (webappUrl: string) => {
  return [
    http.get(
      `${webappUrl}/messages`,
      withSession(({ state }) => {
        return successResponse(state.messages);
      }),
    ),

    http.post(
      `${webappUrl}/threads/:threadId/messages`,
      withSession<{ threadId: string }, Pick<SendMessageRequest, "content">>(
        async ({ request, state }) => {
          const { content } = await request.json();

          if (!content?.trim()) {
            return errorResponse({
              status: 422,
              code: "validation_error",
              message: "The given data was invalid.",
              fields: { content: ["The message cannot be empty."] },
            });
          }

          return successResponse(appendMessage(state, { type: MESSAGE_TYPE.USER, content }), {
            status: 201,
          });
        },
      ),
    ),
  ];
};
